import { KYMW2100Model } from '../kymw2100.model';
import { OrderNumListModel } from '../vo/order-num-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';

/**
 * 注文コード設定をするサービス
 *
 * @export UpdateIndividuallyOrderNumService
 * @class UpdateIndividuallyOrderNumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateIndividuallyOrderNumService extends PlessJsonResponderSub<any> {

  private model: KYMW2100Model;
  private vo = new OrderNumListModel();

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateIndividuallyOrderNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        Rec: {
          condition: {
            OrderCode: this.vo.OrderCode,
            MediumType: this.vo.MediumType,
            CoopCode: this.vo.CoopCode
          },
          combination: this.vo.OrderNumVOList.map(orderNumVO => {
            return {
              condition: {
                PCode: orderNumVO.PCode,
                ItemCode: orderNumVO.ItemCode,
                OrderNum: orderNumVO.OrderNum,
                CouponGoodsNo: orderNumVO.CouponGoodsNo,
                CouponDiv: orderNumVO.CouponDiv,
                PreOrderDetailId: orderNumVO.PreOrderDetailId,
                NvalDetailId: orderNumVO.NvalDetailId
              }
            };
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateIndividuallyOrderNumService
   */
  execute(model: KYMW2100Model, vo: OrderNumListModel): void {
    this.model = model;
    this.vo = vo;
    this.send('updateIndividuallyOrderNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateIndividuallyOrderNumService
   */
  success(data: any): void {
    if (data !== null) {
      // 注文コードの存在チェック
      // 注文コードをリストに格納
      const orderNumList = data.OrderNum;
      // 注文コードが1件以上の場合
      if (!PlessViewUtilsSub.isEmptyArray(orderNumList)) {
        // 注文コードをカンマ区切りで結合し、警告ダイアログを表示する。
        const orderNumString = orderNumList.join(",");
        this.dialogService.openAlertGetMessage('E0647', [orderNumString], (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes_Error) {
            // 注文コード一覧を最新の情報に更新
            this.model.kymw2100Component.reloadOrderNumList();
            //  企画ロックを解除する
            this.model.kymw2100Component.releaseLockInfoCatalog();
          }
        });
      } else {
        // 注文コード一覧を最新の情報に更新
        this.model.kymw2100Component.reloadOrderNumList();
        //  企画ロックを解除する
        this.model.kymw2100Component.releaseLockInfoCatalog();
      }
    }
  }
}
